import { useContext } from 'react'

import { ShopAndRuntimeConfigContext } from 'views/components/templates/helpers'
import { PublicConfig, PageProperties } from 'server/shop-config/types'

export const getPublicConfig = (): PublicConfig => {
  const { publicConfig } = useContext(ShopAndRuntimeConfigContext)

  return publicConfig as PublicConfig
}

export const getPageProperties = (): PageProperties => {
  const { pageProperties } = useContext(ShopAndRuntimeConfigContext)

  return pageProperties as PageProperties
}
